import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashAccountMachineRecordDetails from "../CashAccountMachineRecordDetails";
import ModelProxyClass from "./ModelProxyClass";
import ReportedVgtMachine from "../ReportedVgtMachine";
import Person from "../Person";


/**
 * @class CashAccountMachineRecordDetailsBase
 * @extends ModelBaseClass
 * @property {number} locationId (int64)
 * @property {'Vgt'|'Rt'} type
 * @property {string} licenseNumber
 * @property {string} serialNumber
 * @property {string} vgtSpotName only used if type is Vgt
 * @property {ReportedVgtMachine} linkedReportedVgtMachine only used if type is Vgt
 * @property {'M3tRms'} rtVendorType only used if type is Rt
 * @property {string} rtVendorIdentifier only used if type is Rt
 * @property {Date} dateLastRamClear (date and time)
 * @property {boolean} lastRamClearIndicator if last RAM clear was emergency RAM cleared, this will be true.  If last was standard (non-emergency) RAM clear, this will be false.  Otherwise, if no last ram clear this will be NULL
 * @property {Person} lastRamClearByPerson
 */
class CashAccountMachineRecordDetailsBase extends ModelBaseClass {
	/**
	 * @type {number} locationId (int64)
	 */
	locationId;
	/**
	 * @type {'Vgt'|'Rt'} type
	 */
	type;
	/**
	 * @type {string} licenseNumber
	 */
	licenseNumber;
	/**
	 * @type {string} serialNumber
	 */
	serialNumber;
	/**
	 * only used if type is Vgt
	 * @type {string} vgtSpotName
	 */
	vgtSpotName;
	/**
	 * only used if type is Vgt
	 * @type {ReportedVgtMachine} linkedReportedVgtMachine
	 */
	linkedReportedVgtMachine;
	/**
	 * only used if type is Rt
	 * @type {'M3tRms'} rtVendorType
	 */
	rtVendorType;
	/**
	 * only used if type is Rt
	 * @type {string} rtVendorIdentifier
	 */
	rtVendorIdentifier;
	/**
	 * @type {Date} dateLastRamClear (date and time)
	 */
	dateLastRamClear;
	/**
	 * if last RAM clear was emergency RAM cleared, this will be true.  If last was standard (non-emergency) RAM clear, this will be false.  Otherwise, if no last ram clear this will be NULL
	 * @type {boolean} lastRamClearIndicator
	 */
	lastRamClearIndicator;
	/**
	 * @type {Person} lastRamClearByPerson
	 */
	lastRamClearByPerson;

	/**
	 * Instantiates a new instance of CashAccountMachineRecordDetails based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashAccountMachineRecordDetails}
	 */
	static create(genericObject) {
		const newCashAccountMachineRecordDetails = new CashAccountMachineRecordDetails();
		newCashAccountMachineRecordDetails.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashAccountMachineRecordDetails;
	}

	/**
	 * Instantiates a new array of CashAccountMachineRecordDetails based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashAccountMachineRecordDetails]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashAccountMachineRecordDetailsArray = [];
		genericArray.forEach(genericObject => {
			newCashAccountMachineRecordDetailsArray.push(CashAccountMachineRecordDetails.create(genericObject));
		});
		return newCashAccountMachineRecordDetailsArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('locationId', 'integer'),
	ModelBaseClass.createModelProperty('type', 'string'),
	ModelBaseClass.createModelProperty('licenseNumber', 'string'),
	ModelBaseClass.createModelProperty('serialNumber', 'string'),
	ModelBaseClass.createModelProperty('vgtSpotName', 'string'),
	ModelBaseClass.createModelProperty('linkedReportedVgtMachine', 'ReportedVgtMachine'),
	ModelBaseClass.createModelProperty('rtVendorType', 'string'),
	ModelBaseClass.createModelProperty('rtVendorIdentifier', 'string'),
	ModelBaseClass.createModelProperty('dateLastRamClear', 'datetime'),
	ModelBaseClass.createModelProperty('lastRamClearIndicator', 'boolean'),
	ModelBaseClass.createModelProperty('lastRamClearByPerson', 'Person'),
];

export default CashAccountMachineRecordDetailsBase;
